export default ({ color }: { color?: string }) => {
  return (
    <svg width="50" height="50" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M29.2955 14.6231C29.7227 15.0502 29.7227 15.7427 29.2955 16.1699L19.0872 26.3782C18.6601 26.8054 17.9675 26.8054 17.5404 26.3782L11.7071 20.5449C11.2799 20.1177 11.2799 19.4252 11.7071 18.9981C12.1342 18.571 12.8267 18.571 13.2539 18.9981L18.3138 24.058L27.7487 14.6231C28.1759 14.196 28.8684 14.196 29.2955 14.6231Z" fill="#00AA5B"/>
    </svg>
  );
};
